import { render, staticRenderFns } from "./GiftExternalList.vue?vue&type=template&id=1f7f5bce&"
import script from "./GiftExternalList.vue?vue&type=script&lang=js&"
export * from "./GiftExternalList.vue?vue&type=script&lang=js&"
import style0 from "./GiftExternalList.vue?vue&type=style&index=0&id=1f7f5bce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports